<template>
  <div v-loading="loading">
    <el-row>
      <br>
      <el-form :inline="true"
               class="demo-form-inline">
        <el-form-item label="概念选择">
          <el-select @change="getSearchConceptLogs"
                     value-key="bk_code"
                     filterable
                     v-model="curConcept"
                     remote
                     :remote-method="searchConcept"
                     default-first-option
                     placeholder="请输入概念名称">
            <el-option-group label="搜索结果">
              <el-option v-for="item in conceptOptions"
                         :key="item.bk_code"
                         :label="item.bk_name"
                         :value="item">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary"
                     @click="quickGenConcept(curConcept.bk_code,'普通搜索')">分析一下</el-button>
          <el-button @click="searchConceptDialog=true"><i class="iconfont"
               style="font-size:14px!important;color:#aaa">&#xe62c;</i>&nbsp;查询公司所属概念</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row :gutter="10"
            style="padding-left:75px;">
      <span style="margin:0px;font-size:12px">近日新增概念</span>
      <div style="clear:both;height:10px"></div>
      <template v-for="(item,index) in latestConcepts">
        <template v-if="index <12">
          <template v-if="index === 6"><br :key="index"></template>
          <span style="font-size:0.8rem;width:125px;display: inline-block;"
                :key="item.bk_code">
            <el-link :underline="false"
                     @click="quickGenConcept(item.bk_code,'近日新增概念')">{{item.bk_name.trim()}}</el-link>&nbsp;&nbsp;&nbsp;

          </span>

        </template>
      </template>
      <div style="clear:both;height:25px"></div>
    </el-row>

    <el-row>
      <el-tabs type="card">
        <el-tab-pane label="涨幅榜">
          <el-row>
            <el-col :span="14">
              <h3>
                <img src="../../assets/imgs/stock_up.png"
                     width="12px" /> 涨幅榜TOP10
              </h3>
            </el-col>
            <el-col :span="10"
                    style="text-align:right">
              <div style="clear:both;height:25px"></div>
              <span style="color:#888;font-size:0.8em">榜单日期:&nbsp;{{conceptUpDlowList.date}}</span>
            </el-col>
          </el-row>
          <br>

          <el-table :data="conceptUpDlowList && conceptUpDlowList.up"
                    v-loading="!(candidateConcept && candidateConcept.length>0)">
            <el-table-column label="概念名称"
                             prop="bk_name">
            </el-table-column>
            <el-table-column label="收盘价(元)"
                             prop="latest_price">
            </el-table-column>
            <el-table-column label="涨跌幅(%)">
              <template slot-scope="scope">
                <template v-if="parseFloat(scope.row.chg) >= 0">
                  <span style="color:red"> {{scope.row.chg}}↑</span>
                </template>
                <template v-else>
                  <span style="color:green"> {{scope.row.chg}}↓</span>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="总市值(亿)"
                             prop="total_market_value">
            </el-table-column>
            <el-table-column label="换手率(%)"
                             prop="turnover_rate">
            </el-table-column>
            <el-table-column label="上涨家数"
                             prop="up_counter">
            </el-table-column>
            <el-table-column label="下跌家数"
                             prop="down_counter">
            </el-table-column>
            <el-table-column label="领涨股简称"
                             prop="leading_stocks">
            </el-table-column>
            <el-table-column label="领涨股涨跌幅(%)"
                             prop="leading_stocks_chg">
            </el-table-column>

            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button @click="quickGenConcept(scope.row.bk_code,'涨幅榜')"
                           type="text"
                           size="small">生成报告</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="跌幅榜">
          <el-row>
            <el-col :span="14">
              <h3>
                <img src="../../assets/imgs/stock_down.png"
                     width="12px" />
                跌幅榜TOP10
              </h3>
            </el-col>
            <el-col :span="10"
                    style="text-align:right">
              <div style="clear:both;height:25px"></div>
              <span style="color:#888;font-size:0.8em">榜单日期:&nbsp;{{conceptUpDlowList.date}}</span>
            </el-col>

          </el-row>
          <br>
          <el-table :data="conceptUpDlowList && conceptUpDlowList.down"
                    v-loading="!(candidateConcept && candidateConcept.length>0)">
            <el-table-column label="概念名称"
                             prop="bk_name">
            </el-table-column>
            <el-table-column label="收盘价(元)"
                             prop="latest_price">
            </el-table-column>
            <el-table-column label="涨跌幅(%)">
              <template slot-scope="scope">
                <template v-if="parseFloat(scope.row.chg) >= 0">
                  <span style="color:red"> {{scope.row.chg}}↑</span>
                </template>
                <template v-else>
                  <span style="color:green"> {{scope.row.chg}}↓</span>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="总市值(亿)"
                             prop="total_market_value">
            </el-table-column>
            <el-table-column label="换手率(%)"
                             prop="turnover_rate">
            </el-table-column>
            <el-table-column label="上涨家数"
                             prop="up_counter">
            </el-table-column>
            <el-table-column label="下跌家数"
                             prop="down_counter">
            </el-table-column>
            <el-table-column label="领涨股简称"
                             prop="leading_stocks">
            </el-table-column>
            <el-table-column label="领涨股涨跌幅(%)"
                             prop="leading_stocks_chg">
            </el-table-column>

            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button @click="quickGenConcept(scope.row.bk_code,'跌幅榜')"
                           type="text"
                           size="small">生成报告</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-row>

    <!--类型选择框-->
    <el-dialog width="500px"
               :visible.sync="conceptDialogVisible">
      <div class="c_p"
           slot="title"><b>{{(curConcept.bk_name)||'概念分析'}}</b></div>

      <el-form>
        <el-form-item label="文件类型">
          <template>
            <el-radio v-model="conceptFileType"
                      label="PDF">PDF</el-radio>
            <el-radio v-model="conceptFileType"
                      label="DOC">word</el-radio>
          </template>
        </el-form-item>
        <GenDialog />
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="conceptDialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="inputGenConcept">生 成</el-button>
      </div>
    </el-dialog>

    <el-dialog width="500"
               top="0"
               :close-on-click-modal=false
               :visible.sync="pdfDialogVisible">
      <iframe :src="pdfUrl+'#toolbar=0'"
              title=""
              style="width: 100%;height: calc(100vh - 120px);border: 0;" />
      <div style="text-align:center">
        <el-button @click="toDownPdf(curSourceId)"
                   size="small">下载</el-button>
      </div>
    </el-dialog>

    <!--搜索概念的dialog-->
    <el-dialog :visible.sync="searchConceptDialog"
               width="550px"
               custom-class="conceptSearchLogContainer">
      <div slot="title">
        查询概念
        <el-divider style="margin: 10px 0px;"></el-divider>
      </div>

      <el-row>
        <el-form :inline="true"
                 class="demo-form-inline">
          <el-form-item label="股票选择">
            <el-select style="width:300px"
                       v-model="searchStock0001"
                       @focus="showConceptSearchLogs"
                       @change="searchConceptByStock"
                       value-key="bk_code"
                       filterable
                       remote
                       :remote-method="searchStock"
                       placeholder="请输入需要查询概念的股票名称或代码">
              <el-option-group label="搜索结果">
                <el-option v-for="item in options"
                           :key="item.symbol"
                           :label="item.name"
                           :value="item.symbol">
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
        </el-form>

        <template v-if="conceptOfStockRes && conceptOfStockRes.length>0">
          <h5 style="margin:10px 0px">搜索结果</h5>
          <template v-for="(item,index) in conceptOfStockRes">
            <template v-if="index <20">
              <el-col :span="6"
                      :key="item.concept_code">
                <span style="font-size:0.8rem">
                  <el-link :underline="false"
                           @click="quickGenConcept(item.concept_code,'根据股票搜索')">{{item.concept_name}}</el-link>&nbsp;&nbsp;&nbsp;
                </span>
              </el-col>
            </template>
          </template>
        </template>
        <template v-else-if="searchStock0001.bk_code">
          <h5 style="margin:10px 0px">搜索结果</h5>
          <div style="line-height:20px;">
            <br>
            <img src="../../assets/imgs/emptyTable.png" />
            <div> 暂无搜索记录！</div>
            <br>
          </div>
        </template>
        <template v-else>
          <h5 style="margin:10px 0px">近日新增概念</h5>
          <template v-for="(item,index) in latestConcepts">
            <template v-if="index <20">
              <el-col :span="6"
                      :key="item.bk_code">
                <span style="font-size:0.8rem">
                  <el-link :underline="false"
                           @click="quickGenConcept(item.bk_code,'近日新增')">{{item.bk_name}}</el-link>&nbsp;&nbsp;&nbsp;
                </span>
              </el-col>

            </template>
          </template>
        </template>
      </el-row>
    </el-dialog>

  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import GenDialog from './GenDialog.vue'
export default {
  name: 'ele',
  data: function () {
    return {
      curConcept: {},
      reportType: 'SIMPLE',
      fileType: 'PDF',
      options: [],
      searchConceptDialog: false,
      searchStock0001: {},

      pdfUrl: '',
      loading: false,

      pdfDialogVisible: false,
      tabsName: 'concept',

      curSourceId: '',
      typeDialogVisible: false,

      conceptOptions: [],
      candidateConcept: [],
      conceptUpDlowList: {
        column: {}
      },
      conceptFileType: 'PDF',
      bkCode: {},

      searchLogs: [],

      conceptDialogVisible: false,
      conceptSearchLogs: [],

      selectDialogVisible: false,
      searchTimer: null,
      conceptOfStockRes: [],
      candidateOptions: [],
      latestConcepts: [],
      reportId: ''

    }
  },

  components: {
    GenDialog
  },

  watch: {
    payResult: function () {
      this.reportId = this.$store.state.payData.id
      if (this.reportId) {
        this.getReportStatus()
      }
    }
  },

  filters: {
    dateFilter: function (v) {
      return moment(new Date(parseInt(v))).format('YYYY-MM-DD')
    }
  },

  computed: {
    payResult: function () {
      return this.$store.state.payResult
    },
    userInfo: function () {
      let temp = localStorage.getItem('userinfo')
      if (temp) {
        return JSON.parse(temp)
      }
      return null
    },
    accountinfo: function () {
      let temp = localStorage.getItem('accountinfo')
      if (temp) {
        return JSON.parse(temp)
      }
      return {}
    }
  },
  methods: {
    searchStock (query) {
      query = query.trim()
      let _this = this
      if (_this.searchTimer) {
        clearTimeout(_this.searchTimer)
      }
      _this.searchTimer = setTimeout(() => {
        _this.options = _this.candidateOptions.filter(item => {
          return ((item.name.toLowerCase().indexOf(query.toLowerCase()) > -1) || (item.ts_code.toLowerCase().indexOf(query.toLowerCase()) > -1) || (item.pinyin.toLowerCase().indexOf(query.toLowerCase()) > -1))
        })
      }, 500)
    },
    quickGenConcept (bkCode, source) {
      if (!bkCode) {
        this.$message.error('请选择概念')
        return
      }
      this.searchConceptDialog = false
      let _this = this
      this.candidateConcept.forEach(i => {
        if (i.bk_code === bkCode) {
          _this.conceptOptions = []
          _this.bkCode = bkCode
          _this.curConcept = i
          _this.conceptOptions.push(i)
          _this.conceptDialogVisible = true
        }
      })
      if (source) {
        // eslint-disable-next-line no-undef
        _hmt.push(['_trackEvent', '生成概念报告来源', source])
      }
    },

    inputGenConcept () {
      let _this = this
      _this.conceptDialogVisible = false
      this.loading = true
      axios.get('/api/web/concept/genReport/' + _this.conceptFileType + '/CONCEPT/' + this.bkCode).then(resp => {
        _this.pdfUrl = ''
        _this.reportId = resp.data.id
        _this.$store.commit('toFreshUserPrice')
        _this.getReportStatus()
      }).catch(e => {
        _this.loading = false
        if (e.code === 401) {
          _this.$alert(e.msg, '您的使用次数已超过限制，需要更多权限，请联系客服。')
        }
      })
    },

    getReportStatus () {
      let _this = this
      axios.get('/api/web/stock/reportInfo/' + _this.reportId).then(resp => {
        _this.loading = true
        if (resp.data.status === 'DOING') {
          setTimeout(() => {
            _this.getReportStatus(_this.reportId)
          }, 2000)
        } else if (resp.data.status === 'FINISH') {
          _this.loading = false
          _this.sourceId = resp.data.sourceId
          if (resp.data.fileType === 'PDF') {
            _this.pdfDialogVisible = true
            _this.pdfUrl = '/api/web/stock/readPdf/' + this.sourceId
            _this.pdfDialogVisible = true
          } else {
            _this.toDownPdf()
          }
        } else {
          _this.loading = false
          _this.$notify.error({
            title: '失败',
            message: '报告生成失败，请稍候重试。'
          })
        }
      })
    },

    showSearchLogs () {
      this.options = this.searchLogs
    },
    showConceptSearchLogs () {
      this.conceptOptions = this.conceptSearchLogs
    },

    searchConcept (query) {
      let _this = this
      if (query !== '') {
        setTimeout(() => {
          _this.conceptOptions = _this.candidateConcept.filter(item => {
            return ((item.bk_code.toLowerCase().indexOf(query.toLowerCase()) > -1) || (item.bk_name.toLowerCase().indexOf(query.toLowerCase()) > -1))
          })
        }, 200)
      } else {
        this.conceptOptions = []
      }
    },
    openTypeDialog (code) {
      if (!code) {
        this.$message.error('请选择概念')
        return
      }
      this.bkCode = code
      this.conceptDialogVisible = true
    },

    toDownPdf () {
      window.open('/api/web/stock/downLoadReport/' + this.sourceId)
    },

    getSearchConceptLogs (item) {
      let url = '/api/web/stock/conceptSearchLogs'
      if (item && item.bk_code) {
        url = url + '?code=' + item.bk_code
      }
      let _this = this
      axios.get(url).then(resp => {
        _this.conceptSearchLogs = resp.data
      })
    },

    toRead (sourceId) {
      let _this = this
      _this.pdfUrl = '/api/web/stock/readPdf/' + sourceId
      _this.pdfDialogVisible = true
    },

    getCompareHistory () {
      let _this = this
      axios.get('/api/web/stock/compareHistory').then(resp => {
        _this.compareHistory = resp.data
      })
    },
    getSearchLogs (item) {
      let url = '/api/web/stock/searchLogs'
      if (item && item.ts_code) {
        url = url + '?code=' + item.ts_code
      }
      let _this = this
      axios.get(url).then(resp => {
        _this.searchLogs = resp.data
      })
    },

    searchStockBySelect () {
      let _this = this
      axios.post('/api/web/stock/stockSearchList', this.selectForm).then(resp => {
        _this.searchStocks = resp.data
      })
    },
    searchRelateStock () {
      let _this = this
      let temp = this.compareStocks.slice(-1)[0].symbol
      axios.get('/api/web/stock/searchRelateStocks?stock=' + temp).then(resp => {
        _this.compareOptions = resp.data
      })
    },
    searchConceptByStock (stock) {
      let _this = this
      axios.get('/api/web/stock/getConceptByStock?stock=' + stock).then(resp => {
        _this.conceptOfStockRes = resp.data
      })
    }
  },

  mounted () {
    let _this = this

    try {
      this.candidateOptions = JSON.parse(localStorage.getItem('candidateOptions'))
      if (localStorage.getItem('candidateConcept')) {
        this.candidateConcept = JSON.parse(localStorage.getItem('candidateConcept'))
      }
      this.conceptUpDlowList = localStorage.getItem('conceptUpDlowList')
    } catch (e) {
      console.error(e)
    }
    axios.get('/api/web/stock/list').then(resp => {
      _this.candidateOptions = resp.data
      localStorage.setItem('candidateOptions', JSON.stringify(_this.candidateOptions))
      _this.loading = false
    })

    axios.get('/api/web/concept/concepts').then(resp => {
      _this.candidateConcept = resp.data
      localStorage.setItem('candidateConcept', JSON.stringify(_this.candidateConcept))
    })
    axios.get('/api/web/concept/upDowList').then(resp => {
      _this.conceptUpDlowList = resp.data
      localStorage.setItem('conceptUpDlowList', JSON.stringify(_this.conceptUpDlowList))
    })
    axios.get('/api/web/concept/latestConcept').then(resp => {
      _this.latestConcepts = resp.data
    })

    this.getSearchConceptLogs()
  }
}
</script>
<style lang="less" scoped>
.openCloseIframe {
  border: 0px;
  width: 603px;
  height: calc(100vh - 203px);
}
.container-fluid {
  background: url('/static/img/courses-header.jpg');
  height: 400px;
}
.mydropzone {
  background: #0000;
  border: dashed 2px #fff6;
  border-radius: 10px;
  top: 50%;
  position: relative;
}
.mydropzone:focus {
  background: #0000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/index/concept.vue